<template>
  <div
    class="container opportunities-block">
    <div
      v-if="sub_title"
      class="opportunities-block__sub_title" v-html="sub_title"/>
    <div
      v-if="getIsMobile"
      class="opportunities-block__carousel mt-30 mx-auto">
      <swiper
        class="position-relative nav_buttons_inside"
        next_btn_class="image_next_btn"
        prev_btn_class="image_prev_btn"
        add_navigation_buttons
        :space_between="10"
        :slides_per_view="2">
        <swiper-slide
          v-for="(opportunity, index) in opportunities"
          :key="`swiper-slide_${index}_${uid}`">
          <opportunities-block-item
            :item="opportunity"
            ref="opportunities"/>
        </swiper-slide>
      </swiper>
    </div>

    <div
      v-else
      class="opportunities-block_row inline-xs-row">
      <opportunities-block-item
        v-for="(opportunity, i) in opportunities"
        :item="opportunity"
        ref="opportunities"
        :key="`opportunities-${i}`"/>
    </div>
    <div class="opportunities-block_link">
      <default-button
        :href="button_link">
        {{ button_text }}
      </default-button>
    </div>
  </div>
</template>

<script>
import DefaultButton from "../slots/DefaultButton.vue";
import YellowIcon from "../small_parts/YellowIcon.vue";
import {mapGetters} from "vuex";
import Swiper from "../modules/Swiper/Swiper.vue";
import SwiperSlide from "../modules/Swiper/SwiperSlide.vue";
import LazyImage from "../small_parts/LazyImage.vue";
import BlockquoteIcon from "../icons/BlockquoteIcon.vue";
import HtmlBlock from "../small_parts/HtmlBlock.vue";
import OpportunitiesBlockItem from "../small_parts/OpportunitiesBlockItem.vue";
import uid_mixin from "../../mixins/uid_mixin";

export default {
  name: "OpportunitiesBlock",
  mixins: [uid_mixin],
  components: {
    OpportunitiesBlockItem,
    HtmlBlock,
    BlockquoteIcon,
    LazyImage,
    SwiperSlide,
    Swiper,
    YellowIcon,
    DefaultButton
  },
  props: {
    /**props**/
    sub_title: {
      type: String,
      default: '',
      required: true,
      admin_type: 'textarea',
    },
    button_text: {
      type: String,
      default: '',
      required: true,
      admin_type: 'input',
    },
    button_link: {
      type: String,
      required: true,
      default: '',
      admin_type: 'input',
    },
    opportunities: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        icon: {
          type: String,
          default: '',
          admin_type: 'select',
          admin_data_values: [
            'going_up.svg',
            'light_bulb.svg',
            'line.svg',
            'star.svg',
            'puzzle.svg',
            'target.svg',
            'earth.svg',
            'bag.svg',
            'hand_shake.svg',
            'flag.svg',
            'diagram.svg'
          ],
        },
        title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        text: {
          type: String,
          default: '',
          admin_type: 'input',
        },
      },
    },
    /**props**/
  },
  computed: {
    ...mapGetters([
      'getResolution',
      'getIsMobile'
    ]),
  },
  mounted() {
    setTimeout(this.calculateDesktopHeight, 0)
  },
  methods: {
    calculateDesktopHeight() {
      let offset_list = {};
      let opportunities = this.getTitles();
      opportunities.forEach((el, i) => {
        let children = el.children[0]
        offset_list[el.offsetTop] = offset_list[el.offsetTop] || 0
        if (!children || offset_list[el.offsetTop] > children.clientHeight) return
        offset_list[el.offsetTop] = children.clientHeight
      })
      for (let i = 0; i < opportunities.length; i++) {
        let el = opportunities[i]
        let min_height = offset_list[el.offsetTop]
        if (!min_height) { // over calculate as template moved
          return this.calculateDesktopHeight()
        }
        el.style.minHeight = `${min_height}px`
      }
    },
    getTitles() {
      return (this.$refs.opportunities || []).map(el => {
        return el.$refs.opportunity_title
      })
    }
  },
  watch: {
    'getResolution'() {
      setTimeout(this.calculateDesktopHeight)
    }
  }
}
</script>
